export function saveChatSessionIdInLocalStore(chatUid) {
  localStorage.setItem('chat-session-id', chatUid)
}

export function getChatSessionIdFromLocalStore() {
  return localStorage.getItem('chat-session-id')
}

export function get_conversation_id() {
  let id = localStorage.getItem('conversation-id')
  if (!id || id === 'null') {
    id = ''
  }
  return id
}

export function getChineseWeekday(weekdayEnglish) {
  const weekdayMap = {
    'Monday': '星期一',
    'Tuesday': '星期二',
    'Wednesday': '星期三',
    'Thursday': '星期四',
    'Friday': '星期五',
    'Saturday': '星期六',
    'Sunday': '星期日',
  }
  return weekdayMap[weekdayEnglish]
}

export function set_conversation_id(id) {
  return localStorage.setItem('conversation-id', id)
}

export class PageHandle {
  constructor(list = [], current = 1, size = 10) {
    this.list = list
    this.current = current
    this.size = size
  }

  getTotal() {
    return this.list.length
  }

  getPages() {
    return Math.ceil(this.getTotal() / this.size)
  }

  // 获取当前页数据
  getCurrentPageList() {
    const start = (this.current - 1) * this.size
    const end = start + this.size
    return this.list.slice(start, end)
  }

}


